<template>
  <div class="input-group" :style="fieldStyles()">
    <field-icon :fieldData="fieldData"></field-icon>
    <money
    :ref="fieldData.field_name"
    :disabled="(!!showDisabled())"
    :aria-describedby="`${fieldData.field_name}_describedby`"
    v-model="fieldData.field_value"
    :maxlength="masked_num_maxlength(fieldData.max_length, field_rules)"
    :id="fieldData.field_name"
    @blur.native="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) : ''"
    @keyup.native="inputCalculation(fieldData.field_name)"
    v-bind:class="{'form-control': true, 'error': errors.has(fieldData.field_name) || fieldData.has_error}">
    </money>
    <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
    <input
    :disabled="(!!showDisabled())"
    v-show="false"
    :name="fieldData.field_name"
    type="text"
    class="form-control"
    :maxlength="fieldData.max_length"
    v-model="fieldData.field_value"
    v-validate="field_rules"
    data-vv-validate-on="change"
    >
  </div>
</template>

<script>
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'fieldRules', 'formIndex'],
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  methods: {
    inputCalculation() {
      const validationRule = (this.fieldData.rules[0] ? JSON.parse(this.fieldData.rules[0].rule) : {});
      const dispatchAction = validationRule.dispatch_action;

      // TODO: Refactor to use the same dispatch action for both loading and updating.
      this.$store.dispatch(dispatchAction, { index: this.formIndex, value: this.fieldData.field_value, action: 'input' });
    },
    /**
     * Sets the input element's `maxlength`.
     * Masked input elements add comma-delimited characters to numbers. This returns
     * the resulting `maxlength` by using either 1) the maximum valid numeric value,
     * or 2) the non-masked "maxlength" value.
     */
    masked_num_maxlength(originalMaxlength, fieldRules = null) {
      /* eslint radix:  */
      let numerator = parseInt(originalMaxlength);
      let divisor = 3; // Commas delimite once per 3 numeric characters
      let maxlength = numerator; // Start with the non-masked maxlength
      // If available, use the validation rules `max_value` instead
      if (fieldRules && fieldRules.max_value) {
        numerator = fieldRules.max_value;
        divisor = 1000; // Commas delimite once per division of 1,000
        maxlength = numerator.toString().length; // Start with the amount of numeric characters in the max value
      }
      // eslint-disable-next-line
      while ((numerator = parseInt(numerator / divisor)) && numerator > 0) {
        maxlength += 1;
      }
      return maxlength;
    },
  },
  created() {
    const validationRule = (this.fieldData.rules[0] ? JSON.parse(this.fieldData.rules[0].rule) : {});
    const dispatchAction = validationRule.dispatch_action;
    if (dispatchAction) {
      this.$store.dispatch(dispatchAction, { index: this.formIndex, value: this.fieldData.field_value });
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputCalculation.vue?6005fb35